import Api from "../helpers/api";

export const vratDataZPrieniku = async (layer) => {
  try {
    const response = await Api.post(`/api/v1/smartmap/intersect`, layer);
    return response || false;
  } catch (error) {
    console.error(error);
  }
};
